// extracted by mini-css-extract-plugin
export default {"fields":"LnJK67","time":"_4c0n1","mobile":"L8X0aH"};